import logoPlaceholder from "./assets/tournament-team-placeholder.png";
import bannerPlaceholder from "./assets/tournament-team-banner-placeholder.jpg";

// Match the Expo team's full-size image fallback. Compact tournament avatars
// use the logo artwork even when the team's full profile uses a banner.
export const teamArtworkSrc = (src, mode = "banner") =>
  src || (mode === "logo" ? logoPlaceholder : bannerPlaceholder);

export const teamAvatarSrc = (src) => src || logoPlaceholder;

// A team without uploaded artwork has no banner to display. Show the logo
// placeholder on public tournament surfaces, regardless of its saved edit mode.
export const teamDisplayMode = (src, mode) => src ? (mode === "logo" ? "logo" : "banner") : "logo";
